import { render, staticRenderFns } from "./ChatUnreadBadge.vue?vue&type=template&id=33fdbf08&scoped=true"
import script from "./ChatUnreadBadge.vue?vue&type=script&lang=js"
export * from "./ChatUnreadBadge.vue?vue&type=script&lang=js"
import style0 from "./ChatUnreadBadge.vue?vue&type=style&index=0&id=33fdbf08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fdbf08",
  null
  
)

export default component.exports